import RemoveLink from 'components/GlobalModals/SavedForLaterModal/RemoveLink/RemoveLink.f';

export default RemoveLink;
